import React from "react";
import { Descriptions } from "antd";
import {
	usePreguntasPuntualidad,
	usePreguntasComunicacionReportes,
} from "../../hooks";
import usePreguntasResponsabilidadManejoVehiculo from "../../hooks/usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "../../hooks/usePreguntasActitudTrabajoEquipo";
import usePreguntasPredisposicion from "../../hooks/usePreguntasPredisposicion";
import usePreguntasImagenRepresentacionEmpresa from "../../hooks/usePreguntasImagenRepresentacionEmpresa";
import useResultadoEvaluacionConductor from "../../hooks/useResultadoEvaluacionConductor";
import usePreguntasConocimientosTecnicos from "../../hooks/usePreguntasConocimientosTecnicos";
import usePreguntasCalidadTrabajo from "../../hooks/usePreguntasCalidadTrabajo";
import usePreguntasProductividadEficiencia from "../../hooks/usePreguntasProductividadEficiencia";
import usePreguntasResponsabilidadPuntualidad from "../../hooks/usePreguntasResponsabilidadPuntualidad";
import usePreguntasResolucionProblemaTomaDecisiones from "../../hooks/usePreguntasResolucionProblemaTomaDecisiones";
import usePreguntasTrabajoEnEquipoActitud from "../../hooks/usePreguntasTrabajoEnEquipoActitud";
import useResultadoEvaluacionMecanico from "../../hooks/useResultadoEvaluacionMecanico";

const FactoresEvaluacionMecanico = () => {
	const { puntajeTotal: puntajeTotalConocimientosTecnicos } = usePreguntasConocimientosTecnicos();
	const { puntajeTotal: puntajeTotalCalidadTrabajo } = usePreguntasCalidadTrabajo();
	const { puntajeTotal: puntajeTotalProductividadEficiencia } = usePreguntasProductividadEficiencia();
	const { puntajeTotal: puntajeTotalResponsabilidadPuntualidad } = usePreguntasResponsabilidadPuntualidad();
	const { puntajeTotal: puntajeTotalTrabajoEquipoActitud } = usePreguntasTrabajoEnEquipoActitud();
	const { puntajeTotal: puntajeTotalResolucionProblemaTomaDecisiones } = usePreguntasResolucionProblemaTomaDecisiones();
	const { puntajeTotalEvaluacionMecanico } = useResultadoEvaluacionMecanico();
	return (
		<div style={{ marginBottom: "20px" }}>
			<div style={{ fontWeight: "bold", fontSize: "14px", marginBottom: "5px" }}>FACTORES DE EVALUACIÓN</div>
			<Descriptions bordered size="small" column={1} labelStyle={{ width: "70%" }}>
				<Descriptions.Item label="CONOCIMIENTOS TECNICOS">
					{puntajeTotalConocimientosTecnicos}
				</Descriptions.Item>
				<Descriptions.Item label="CALIDAD DE TRABAJO">
					{puntajeTotalCalidadTrabajo}
				</Descriptions.Item>
				<Descriptions.Item label="PRODUCTIVIDAD Y EFICIENCIA">
					{puntajeTotalProductividadEficiencia}
				</Descriptions.Item>
				<Descriptions.Item label="RESPONSABILIDAD Y PUNTUALIDAD">
					{puntajeTotalResponsabilidadPuntualidad}
				</Descriptions.Item>
				<Descriptions.Item label="RESOLUCION DE PROBLEMA Y TOMA DE DECISIONES">
					{puntajeTotalResolucionProblemaTomaDecisiones}
				</Descriptions.Item>
				<Descriptions.Item label="TRABAJO EN EQUIPO Y ACTITUD">
					{puntajeTotalTrabajoEquipoActitud}
				</Descriptions.Item>
				<Descriptions.Item label="TOTAL">
					{puntajeTotalEvaluacionMecanico}
				</Descriptions.Item>
			</Descriptions>
		</div>
	);
};

export default FactoresEvaluacionMecanico;
